import { enableProdMode } from '@angular/core'; 
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { config } from './environments/config';

if (config.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

/* Adding Favicon img from Datanyze bucket to header - Only in browser */
if (typeof document !== 'undefined') {
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/x-icon';
  link.href = `${config.icons_url}/favicon-icon.png`;
  document.getElementsByTagName('head')[0].appendChild(link);
}
